import React from 'react';
import PropTypes from 'prop-types';

import { uiConfig } from '../../../../../../../../../conf/concepts';

// Components
import Table from '../../../../../../../../../../components/Table';
import { Spinner } from '../../../../../../../../../../components/Spinner';
import { ConstraintTypeModal } from './ConstraintTypeModal';

// Context
import { CriteriaStoreContext } from '../../../../../../../../state/criteria/context';

// Hooks
import { useGetConcepts } from '../../../../../../../../../../common/hooks/useGetConcepts';

// Utils
import { translateUIConfigForTable } from '../../../../../../../../../../common/utility';

export const ConceptTableModal = (props) => {
    const { sessionToken } = React.useContext(CriteriaStoreContext);
    const { data, isLoading } = useGetConcepts({ sessionToken });
    const { columns, initialState } = translateUIConfigForTable(uiConfig);

    return (
        <ConstraintTypeModal header={'Concepts'} id={'constraint-type-concept-modal'} {...props}>
            {!isLoading ? (
                <Table
                    withHeader={true}
                    columns={columns}
                    data={data}
                    withActions={false}
                    rowClickAction={(rowData) => props?.onSelect?.(rowData)}
                    id={'concept-manager'}
                    label={'Concepts'}
                    showControlDeck={true}
                    paginated={true}
                    loading={isLoading}
                    initialState={initialState}
                />
            ) : (
                <Spinner size={'2.3rem'} color={'#7f7f7f'} style={{ margin: '0 auto' }} />
            )}
        </ConstraintTypeModal>
    );
};

ConceptTableModal.propTypes = {
    closeDialog: PropTypes.func.isRequired,
    onSelect: PropTypes.func
};

export default ConceptTableModal;
